/* 
 *  Created by SGiri 02/19/2018
 */

import { Injectable } from '@angular/core';
import { BI_HttpService } from '../../services/http.service';
import { ConfigConstants } from '~config/util/config.constant';

@Injectable()
export class SearchService {

  constructor(private http: BI_HttpService) {
  }

  public getSearchData(searchReq: any) {
    return this.http.post(ConfigConstants.SEARCH_URL, searchReq);
  }

  public exportForRelease(releaseVersion: string) {
    return this.http.postWithOptions(ConfigConstants.EXPORT_FOR_RELEASE_URL, releaseVersion, { responseType: 'text' });
  }

  public getReleaseVersions(isLocationMapping: boolean) {
    return this.http.get(ConfigConstants.GET_RELEASE_VERSIONS_URL + isLocationMapping);
  }

  getSearchTypes(): any[] {
    let types: any[] = [{
      type: 'Name',
      value: 'NAME'
    }, {
      type: 'Release Version',
      value: 'RV'
    }, {
      type: 'Date Created',
      value: 'DC'
    }, {
      type: 'Date Modified',
      value: 'DM'
    }];

    return types;
  }
}


// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/services/search.service.ts